import { v4 as uuid } from 'uuid';

import { responseWithData } from 'utils';

import { EASParams } from 'utils/EASTypes';
import { PrefixFromPersonType } from 'utils/enumMaps';

import { Backend } from './endpoints';

import { api, authEndpoint, infiniteEndpoint } from '.';

// Offer

export const useOffer = authEndpoint<Backend.OfferDetail, [id: string]>(
	['offer'],
	(api, id) => api.get(`offers/${id}/dto`),
	{ refetchOnWindowFocus: false },
);

export const useOfferAdmin = authEndpoint<Backend.Offer, [id: string]>(
	['offer'],
	(api, id) => api.get(`offers/${id}/detailed`),
);

export const useOfferExternal = authEndpoint<
	Backend.OfferDetail,
	[id: string, token: string]
>(['offer'], (api, id, token) => api.get(`offers/${id}/${token}`));

// Offers

export const useOffers = infiniteEndpoint<
	Backend.OfferResultDto | Backend.OfferDetail,
	[json: EASParams]
>(['offers'], (api, json) => api.post('offers/dto', { json }), 50);

export const useOffersAdmin = infiniteEndpoint<
	Backend.OfferAdminList,
	[json: EASParams]
>(['admin', 'offers'], (api, json) => api.post('offers/list', { json }), 50);

// Edit

//FIXME: on BE is /save for company and without /save for admin again
export const saveOffer = (
	json: Partial<Backend.OfferDetail>,
	id: string = uuid(),
	personType?: Backend.CommonPersonType,
) =>
	responseWithData<Backend.Offer>(
		api(PrefixFromPersonType[personType ?? 'PUBLIC']).put(
			`offers/${id}${personType === 'RECRUITER' ? '/save' : ''}`,
			{ json },
		),
	);

export const saveOfferExternal = (
	json: Partial<Backend.OfferDetail>,
	id: string = uuid(),
	token: string,
) =>
	responseWithData<Backend.Offer>(
		api().put(`public/offers/${id}/${token}`, {
			json,
		}),
	);

// Activation

export const offersActivate = async (
	id: string,
	personType: Backend.CommonPersonType,
	validTo: string = (null as unknown) as string,
) =>
	(
		await api(
			PrefixFromPersonType[personType ?? 'PUBLIC'],
		).put(`offers/${id}/activate`, { json: validTo, throwHttpErrors: false })
	)?.ok;

export const offersDeactivate = async (
	id: string,
	personType: Backend.CommonPersonType,
) =>
	(
		await api(PrefixFromPersonType[personType ?? 'PUBLIC']).put(
			`offers/${id}/deactivate`,
			{
				throwHttpErrors: false,
			},
		)
	)?.ok;

// Export
export const exportOffers = (params: EASParams) =>
	api()
		.post(`admin/offers/export`, {
			searchParams: { reportType: 'CSV' },
			json: { ...params, size: -1 },
		})
		.blob();

// Other

export const useCompanyOwnOffers = infiniteEndpoint<Backend.Offer>(
	['offers', 'logged-in'],
	api => api.post('offers/logged-in-company'),
);

// Recommend
export const recommendOffer = (
	json: Backend.OfferAdminUpdate,
	offerId: string,
) => api().put(`admin/offers/${offerId}`, { json });

// set submitted form as read by company
export const readByCompany = (id: string) =>
	api().put(`company/offers/submitted-form/${id}/read`, {
		throwHttpErrors: false,
	});
